import { render, staticRenderFns } from "./ProductsVariationItem.vue?vue&type=template&id=17245bc0"
import script from "./ProductsVariationItem.vue?vue&type=script&lang=js"
export * from "./ProductsVariationItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports